import React, { memo, useCallback } from 'react'

import { FaChevronRight } from 'react-icons/fa'

import { ViewLine, ResultTextStyled } from '../'

export type TextLineProps = {
  disclosure?: boolean
  text: string
  onPress?: () => void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  style?: any
  first?: boolean
  last?: boolean
}
const TextLine = ({ disclosure = true, onPress, text = 'toto', style, first = false, last = false }: TextLineProps) => {
  const _onPress = useCallback(() => {
    if (onPress) {
      onPress()
    }
  }, [onPress])
  return (
    <ViewLine last={last} first={first} justifyContent="center" alignItems="center" style={style} sx={style} onClick={_onPress}>
      <ResultTextStyled>{text}</ResultTextStyled>

      {disclosure && <FaChevronRight color="#94a3b8" size={16} />}
    </ViewLine>
  )
}

export default memo(TextLine)
